var map = {
	"./3-mantar.png": "ede5",
	"./ana-sayfa.png": "3b80",
	"./arka-plan.png": "f19e",
	"./arka-plan.webp": "e512",
	"./bolonez.png": "4676",
	"./cake.png": "1994",
	"./carbonara.png": "c0d2",
	"./chef1.webp": "7ae2",
	"./dessert.png": "c8c4",
	"./dessert2.png": "895b",
	"./food-1.jpg": "a9d5",
	"./food-2.jpg": "4720",
	"./food-3.jpg": "6a1d",
	"./icons/aaa.svg": "749b",
	"./icons/close.svg": "8b1b",
	"./icons/dessert.svg": "9e12",
	"./icons/facebook.svg": "8485",
	"./icons/facebook2.svg": "594c",
	"./icons/hamburger-menu.svg": "b602",
	"./icons/icon1.svg": "3383",
	"./icons/instagram.svg": "bd6c",
	"./icons/noodle.svg": "5f2d",
	"./icons/pasta.svg": "7317",
	"./icons/salad.svg": "41b7",
	"./icons/vegetables.svg": "bac2",
	"./italyan domatesli.png": "1065",
	"./köz patlıcanlı.png": "8439",
	"./limon kremalı avakado.png": "72a3",
	"./location.png": "e6b6",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./makandcis.png": "ceee",
	"./makco-logo.jpeg": "be0a",
	"./makco-logo.png": "59cf",
	"./makfredo.png": "e719",
	"./noodle.png": "b74e",
	"./pesto.png": "97e6",
	"./rabiatta.png": "ffb8",
	"./ramen.png": "d136",
	"./ramen2.png": "07ca",
	"./tailwind.css": "ba8c",
	"./tavuklu ramen.png": "f539",
	"./welcome-page.jpg": "bb68"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";